import { SET_COMPANY_DATA, SET_COMPANY_REGISTRATION_DATA } from '../../actionTypes/company'

const initialState = {
	registrationData: null,
	companyData: null
}

export function companyReducer (state = initialState, action) {
	switch (action.type) {
		case SET_COMPANY_REGISTRATION_DATA:
			return {
				...state,
				registrationData: action.value,
			}
		case SET_COMPANY_DATA:
			return {
				...state,
				companyData: action.value,
			}
		default:
			return state
	}
}


